<template>
	<form class="c-form-workspace-api-key" @submit.prevent="onRegenerate">
		<div class="form-group">
			<label class="form__label">Workspace API key</label>
			<input
				type="text"
				class="form-control c-form-workspace-api-key__input"
				:value="apiKey"
				readonly
				placeholder="No API key available yet"
			/>
			<small class="form-text text-muted">
				Use this key to connect your workspace with API integrations.
			</small>
		</div>

		<button
			type="submit"
			class="btn btn-box btn-primary"
			:disabled="processing || !workspaceId"
		>
			<span class="c-spinner" v-if="processing"></span>
			<span>regenerate key</span>
		</button>
	</form>
</template>

<script>
export default {
	props: {
		workspace: {
			type: Object,
			default: function () {
				return null;
			},
		},
	},

	data: function () {
		return {
			processing: false,
		};
	},

	computed: {
		workspaceId: function () {
			if (!this.workspace) {
				return null;
			}

			return this.workspace.id || null;
		},
		apiKey: function () {
			if (!this.workspace) {
				return '';
			}

			return this.workspace.apiKey || '';
		},
	},

	methods: {
		async onRegenerate() {
			if (!this.workspaceId || this.processing) {
				return;
			}

			this.processing = true;

			let data = await this.$store
				.dispatch('workspaces/refreshApiKey')
				.catch(() => {
					this.$store.dispatch('message/sendMessage', {
						status: 'warning',
						message: 'Could not regenerate API key. Please try again.',
					});
				});

			this.processing = false;

			if (!data) {
				return;
			}

			this.$store.dispatch('message/sendMessage', {
				status: 'success',
				message: 'Workspace API key regenerated.',
			});
		},
	},
};
</script>

<style lang="scss">
.c-form-workspace-api-key {
	.form-group {
		margin-bottom: var(--margin-lg);
	}

	&__input.form-control[readonly] {
		opacity: 1;
		color: var(--color-font-heading);
		background-color: var(--color-bg-1);
		border-color: var(--color-bg-5);
		font-family: var(--font-family-monospace);
		font-size: var(--font-size);
		letter-spacing: 0.2px;
	}

	.c-spinner {
		margin-right: var(--margin);
	}
}
</style>
